import { Box, Divider, Stack, Typography } from "@mui/material";
import React from "react";
import { useStyles } from "./style";

export const AllocatedCard = (props) => {

  // styles
  const classes = useStyles();
  return (
    <div className={classes.allocatedroot}>
      <div
        style={{ padding: "12px", display: "flex", alignItems: "center" }}
      >
        <div style={{ marginInlineEnd: "10px" }}>
          {props?.isImageType ? (
            <img
              alt="img"
              src={props?.viewDetails?.member?.image_url ?? ""}
            // style={{ borderRadius: "4px" }}
            // {...stringAvatar(`${props?.viewDetails?.member?.first_name} ${props?.viewDetails?.member?.last_name}`)}
            />
          ) : (
            props?.viewDetails?.member?.image_url
          )}
        </div>
        <div>
          <Stack direction="row" alignItems="center" spacing={1} divider={<Divider orientation="vertical" flexItem />}>
            <Typography className={classes.profileTilte} noWrap>
              {props?.viewDetails?.member?.first_name ?? ""}{" "}
              {props?.viewDetails?.member?.last_name ?? ""}
            </Typography>
            {props?.viewDetails?.member?.build_source !== null &&
              <Typography className={classes.profileTilte}>{props?.viewDetails?.member?.build_source}</Typography>
            }
          </Stack>
          <Box style={{ display: "flex", alignItems: "center" }}>
            <Box>
              {" "}
              <Typography className={classes.leadcontactNo} noWrap>
                {/* <Box className={classes.dot} /> */}
                {props?.viewDetails?.member?.mobile_no_country_code ?? ""}{" "}
                {props?.viewDetails?.member?.mobile_no ?? ""}
              </Typography>
            </Box>
            <Box>
              {" "}
              {props?.viewDetails?.member?.email_id !== null &&
                <Typography className={classes.leadcontact}>
                  <Box className={classes.dot} />
                  <Typography className={classes.leadcontact} noWrap>
                    {" "}
                    {props?.viewDetails?.member?.email_id ?? ""}
                  </Typography>
                </Typography>
              }
            </Box>
          </Box>
        </div>
      </div>
    </div>
  );
};
